import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import FileUploader from "./components/FileUploader";

const RescheduleInterview = () => {
  // Form validation schema using Yup
  const validationSchema = Yup.object({
    candidate: Yup.string()
      .min(3, "Candidate name must be at least 3 characters")
      .required("Candidate name is required"),
    email: Yup.string()
      .email("Email must have a valid format.")
      .required("Email is required"),
    position: Yup.string()
      .min(2, "Position must be at least 2 characters")
      .required("Position is required"),
    date: Yup.date()
      .required("Interview date is required")
      .typeError("Invalid date format"),
    time: Yup.string().required("Interview time is required"),
    interviewer: Yup.string()
      .min(3, "Interviewer name must be at least 3 characters")
      .required("Interviewer name is required"),
    resume: Yup.mixed().required("Resume is required"),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      candidate: "Jhone Doe",
      email: "jhondoe@example.com",
      position: "Sr. Software Developer",
      date: "2025-02-23",
      time: "12:00",
      interviewer: "Jane Doe",
      resume: null,
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Form Values:", values);
      alert("Interview Added Successfully!");
      formik.resetForm();
    },
  });

  return (
    <DashboardLayout>
      <div className="bg-gray-100 h-full p-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Add New Interview
        </h1>

        <div className="md:mx-10 mx-5 bg-white shadow-md rounded-2xl p-6">
          <form onSubmit={formik.handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-2 items-center">
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Candidate Name
                </label>
                <input
                  type="text"
                  name="candidate"
                  value={formik.values.candidate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter candidate's name"
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.candidate && formik.errors.candidate
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.candidate && formik.errors.candidate && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.candidate}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Candidate Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter email's name"
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.email && formik.errors.email
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Position
                </label>
                <input
                  type="text"
                  name="position"
                  value={formik.values.position}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter position"
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.position && formik.errors.position
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.position && formik.errors.position && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.position}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Interview Date
                </label>
                <input
                  type="date"
                  name="date"
                  value={formik.values.date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.date && formik.errors.date
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.date && formik.errors.date && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.date}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Interview Time
                </label>
                <input
                  type="time"
                  name="time"
                  value={formik.values.time}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.time && formik.errors.time
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.time && formik.errors.time && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.time}
                  </div>
                )}
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-semibold mb-2">
                  Interviewer Name
                </label>
                <input
                  type="text"
                  name="interviewer"
                  value={formik.values.interviewer}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter interviewer's name"
                  className={`w-full border rounded-lg px-4 py-2 focus:outline-none ${
                    formik.touched.interviewer && formik.errors.interviewer
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                {formik.touched.interviewer && formik.errors.interviewer && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.interviewer}
                  </div>
                )}
              </div>
            </div>
            <div className="mb-4">
              <FileUploader
                value={formik.values.resume?.name}
                handleChange={(e) => {
                  formik.setFieldValue("resume", e.target.files[0]);
                }}
              />
              {formik.touched.resume && formik.errors.resume && (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.resume}
                </div>
              )}
            </div>

            <button
              type="submit"
              className="w-full bg-slate-500 text-white py-2 px-4 rounded-lg hover:bg-slate-600 transition"
            >
              Reschedule Interview
            </button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default RescheduleInterview;
